export const MEMES_NOMINEE_CATEGORY = "MemesNominee";
export const MEMES_NOMINEE_REQUIRED_REP = 50_000;
export const MEMES_SEEKING_NOMINATION_WAVE_ID =
  "0ecb95d0-d8f2-48e8-8137-bfa71ee8593c";
